"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Loading;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const ThemeContext_1 = require("../ThemeContext");
const Helper_1 = require("../Helper");
const Button_1 = __importDefault(require("../components/Button"));
const react_i18next_1 = require("react-i18next");
const Maintenance_1 = __importDefault(require("../partials/Maintenance"));
const Error_1 = __importDefault(require("../partials/Error"));
const NextepWhite_svg_1 = __importDefault(require("../images/NextepWhite.svg"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
function Loading(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const styles = react_native_1.StyleSheet.create({
        container: {
            backgroundColor: THEME.PrimaryDark,
            flex: 1
        },
        inner: {
            alignSelf: 'center',
            justifyContent: 'center',
            flex: 1,
            margin: 'auto',
            width: size != 'sm' ? '40%' : '80%'
        }
    });
    const handleUpdate = () => {
        switch (react_native_1.Platform.OS) {
            case 'ios':
                react_native_1.Linking.openURL(Helper_1.Helper.appStoreUrl);
                break;
            case 'android':
                react_native_1.Linking.openURL(Helper_1.Helper.playStoreUrl);
                break;
        }
    };
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.container, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.inner, children: [(0, jsx_runtime_1.jsx)(NextepWhite_svg_1.default, { height: size != 'sm' ? 96 : 64, width: "100%" }), (props.maintenance && props.maintenanceCheck) &&
                    (0, jsx_runtime_1.jsx)(Maintenance_1.default, {}), (props.error && !props.maintenance && props.maintenanceCheck) &&
                    (0, jsx_runtime_1.jsx)(Error_1.default, {}), (props.update && !props.maintenance && props.maintenanceCheck) &&
                    (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginTop: 24 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.AlwaysWhite, fontSize: 22, textAlign: 'center', fontWeight: '500' }, children: t('common:text.updateRequired') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.AlwaysWhite, fontSize: 18, textAlign: 'center', marginTop: 16 }, children: t('common:text.updateInfo') }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flexDirection: 'row', justifyContent: 'center', marginTop: 36 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { color: THEME.AlwaysWhite, onPress: handleUpdate, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { marginHorizontal: 12, color: THEME.PrimaryDark, fontSize: 18, fontWeight: '500' }, children: t('common:buttons.update') }) }) })] }), (!props.error && !props.update && !props.maintenance) &&
                    (0, jsx_runtime_1.jsx)(react_native_1.ActivityIndicator, { size: "large", color: THEME.AlwaysWhite, style: { marginTop: 24 } })] }) }));
}
;
